import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { WhatsAppShareHost } from "./components/WhatsAppShareHost";
import { NetBanner } from "./components/NetBanner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Training from "./pages/Training";
import PPF from "./pages/PPF";
import EWarranty from "./pages/EWarranty";
import WarrantyVerify from "./pages/WarrantyVerify";
import Gallery from "./pages/Gallery";
import Testimonials from "./pages/Testimonials";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout, { firstAllowedPath } from "./components/admin/AdminLayout";
import InventoryDashboard from "./pages/admin/InventoryDashboard";
// eslint-disable-next-line no-unused-vars -- legacy reports page kept for rollback safety
import Reports from "./pages/admin/Reports";
import ChangePassword from "./pages/admin/ChangePassword";
import Inspections from "./pages/admin/Inspections";
import InspectionForm from "./pages/admin/InspectionForm";
import UsedCarInspections from "./pages/admin/inspections/UsedCarInspections";
import UsedCarInspectionForm from "./pages/admin/inspections/UsedCarInspectionForm";
import PublicInspection from "./pages/PublicInspection";
import PayInvoice from "./pages/PayInvoice";
import PublicFeedback from "./pages/PublicFeedback";
import FeedbackPage from "./pages/admin/FeedbackPage";
import ApproveEstimate from "./pages/ApproveEstimate";
import Customers from "./pages/admin/billing/Customers";
import BillingList from "./pages/admin/billing/BillingList";
import CollectionsPage from "./pages/admin/billing/CollectionsPage";
import WarrantiesList from "./pages/admin/billing/WarrantiesList";
import BillingForm from "./pages/admin/billing/BillingForm";
import BillingSettings from "./pages/admin/billing/BillingSettings";
import VehicleCatalog from "./pages/admin/billing/VehicleCatalog";
import ExpensesPage from "./pages/admin/expenses/ExpensesPage";
import RecurringPage from "./pages/admin/expenses/RecurringPage";
import TeamExpensesPage from "./pages/admin/expenses/TeamExpensesPage";
import StaffPage from "./pages/admin/staff/StaffPage";
import PayrollPage from "./pages/admin/staff/PayrollPage";
import MyAttendancePage from "./pages/admin/staff/MyAttendancePage";
import PerformancePage from "./pages/admin/performance/PerformancePage";
import ReviewDetailPage from "./pages/admin/performance/ReviewDetailPage";
import MyPerformancePage from "./pages/admin/performance/MyPerformancePage";
import CalibrationPage from "./pages/admin/performance/CalibrationPage";
import PipsPage from "./pages/admin/performance/PipsPage";
import TeamAnalysisPage from "./pages/admin/performance/TeamAnalysisPage";
import SkillMatrixPage from "./pages/admin/skills/SkillMatrixPage";
import SkillSheetPage from "./pages/admin/skills/SkillSheetPage";
import TrainingPlanPage from "./pages/admin/skills/TrainingPlanPage";
import DutyTemplatesPage from "./pages/admin/skills/DutyTemplatesPage";
import SkillCataloguePage from "./pages/admin/skills/SkillCataloguePage";
import SopLibraryPage from "./pages/admin/sop/SopLibraryPage";
import SopFlowPage from "./pages/admin/sop/SopFlowPage";
import FinanceReportsPage from "./pages/admin/reports/FinanceReportsPage";
import StaffPortal from "./pages/staff/StaffPortal";
import AdminUsersPage from "./pages/admin/access/AdminUsersPage";
import ActivityLogPage from "./pages/admin/access/ActivityLogPage";
import ReportsHub from "./pages/admin/reports/ReportsHub";
import OtReasonsReport from "./pages/admin/reports/OtReasonsReport";
import InventoryReport from "./pages/admin/reports/InventoryReport";
import PartsSalesReport from "./pages/admin/reports/PartsSalesReport";
import PurchasingPage from "./pages/admin/purchasing/PurchasingPage";
import LabourChartPage from "./pages/admin/labour/LabourChartPage";
import DataImportPage from "./pages/admin/setup/DataImportPage";
import PurchasingReports from "./pages/admin/labour/PurchasingReports";
import JobCardsList from "./pages/admin/jobcards/JobCardsList";
import JobCardForm from "./pages/admin/jobcards/JobCardForm";
import InvoicesReport from "./pages/admin/reports/InvoicesReport";
import ExpensesReport from "./pages/admin/reports/ExpensesReport";
import InspectionsPendingReport from "./pages/admin/reports/InspectionsPendingReport";
import RevenueHeadsReport from "./pages/admin/reports/RevenueHeadsReport";
import Gstr2Report from "./pages/admin/reports/Gstr2Report";
import CostCentrePnl from "./pages/admin/reports/CostCentrePnl";
import GstInvoicesList from "./pages/admin/gst/GstInvoicesList";
import GstInvoiceRoute from "./pages/admin/gst/GstInvoiceRoute";
import HsnMasterPage from "./pages/admin/gst/HsnMasterPage";
import GstReturnsPage from "./pages/admin/gst/GstReturnsPage";
import GstSettingsPage from "./pages/admin/gst/GstSettingsPage";
import Marketplace from "./pages/Marketplace";
import MarketplaceCar from "./pages/MarketplaceCar";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import MyListings from "./pages/MyListings";
import SellYourCar from "./pages/SellYourCar";
import AdminMarketplace from "./pages/admin/marketplace/AdminMarketplace";
import AdminMarketplaceForm from "./pages/admin/marketplace/AdminMarketplaceForm";
import AppointmentsPage from "./pages/admin/appointments/AppointmentsPage";
import PickupsPage from "./pages/admin/appointments/PickupsPage";
import AppointmentForm from "./pages/admin/appointments/AppointmentForm";
import TodayCards from "./pages/admin/appointments/TodayCards";
import BookAppointment from "./pages/BookAppointment";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { TenantProvider } from "./contexts/TenantContext";
import { ThemeProvider, useTheme } from "./contexts/ThemeContext";
import WorkshopSignup from "./pages/WorkshopSignup";
import DrivelineHome from "./pages/driveline/DrivelineHome";
import DrivelinePricing from "./pages/driveline/DrivelinePricing";
import DrivelineRefund from "./pages/driveline/DrivelineRefund";
import DrivelineTerms from "./pages/driveline/DrivelineTerms";
import DrivelinePrivacy from "./pages/driveline/DrivelinePrivacy";
import DrivelineGuides from "./pages/driveline/DrivelineGuides";
import SolutionPage from "./pages/driveline/SolutionPage";
import FeaturePage from "./pages/driveline/FeaturePage";
import DrivelineCompare from "./pages/driveline/DrivelineCompare";
import DrivelineSwitch from "./pages/driveline/DrivelineSwitch";
import DrivelineSwitchTrack from "./pages/driveline/DrivelineSwitchTrack";
import DrivelineStories from "./pages/driveline/DrivelineStories";
import MigrationsDesk from "./pages/admin/platform/migrations/MigrationsDesk";
import MigrationDetail from "./pages/admin/platform/migrations/MigrationDetail";
import DemoManage from "./pages/driveline/DemoManage";
import SiteShell from "./pages/driveline/site/SiteShell";
import SubscriptionPage from "./pages/admin/SubscriptionPage";
import PlatformConsole from "./pages/admin/platform/PlatformConsole";
import LeadsInbox from "./pages/admin/platform/LeadsInbox";
import SupportTickets from "./pages/admin/platform/SupportTickets";
import PlatformHealth from "./pages/admin/platform/PlatformHealth";
import PackagesPage from "./pages/admin/platform/PackagesPage";
import { LangProvider } from "./i18n/LangContext";

// Smart landing — staff users (no admin perms) hop straight to
// "My Attendance"; everyone else lands on Inventory as before.
const AdminLanding = () => {
  const { user } = useAuth();
  if (user && user.role === 'staff' && (user.permissions || {}).can_self_mark_attendance) {
    return <Navigate to="/admin/my-attendance" replace />;
  }
  // Land every admin on the first module they can actually open. Master
  // admins keep the inventory dashboard as their home.
  if (user && !user.is_master_admin) {
    const home = firstAllowedPath(user);
    if (home !== '/admin/inventory') return <Navigate to={home} replace />;
  }
  return <InventoryDashboard />;
};

const PublicLayout = ({ children }) => {
  // Driveline pages carry their own navigation and footer.
  const { pathname } = useLocation();
  if (pathname.startsWith('/driveline') || pathname.startsWith('/verify/')) return <>{children}</>;
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
};

// Toasts portal to <body>, so they need telling about the theme directly.
const ThemedToaster = () => {
  const { dark } = useTheme();
  return <Toaster position="top-center" richColors closeButton theme={dark ? 'dark' : 'light'} />;
};

const AppRoutes = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isStaffRoute = location.pathname.startsWith('/staff');
  const isPublicInspectionRoute = location.pathname.startsWith('/inspection/');

  if (isPublicInspectionRoute) {
    return (
      <Routes>
        <Route path="/inspection/:token" element={<PublicInspection />} />
      </Routes>
    );
  }

  // Workshop signup is a full-bleed brand page — no site header/footer.
  if (location.pathname.startsWith('/get-started')) {
    return (
      <Routes>
        <Route path="/get-started" element={<WorkshopSignup />} />
      </Routes>
    );
  }

  if (location.pathname.startsWith('/feedback/')) {
    return (
      <Routes>
        <Route path="/feedback/:token" element={<PublicFeedback />} />
      </Routes>
    );
  }

  // The customer's invoice payment page — workshop-branded, no site chrome.
  if (location.pathname.startsWith('/pay/')) {
    return (
      <Routes>
        <Route path="/pay/:token" element={<PayInvoice />} />
      </Routes>
    );
  }

  // Estimate approval, same treatment — it hands straight over to /pay.
  if (location.pathname.startsWith('/estimate/')) {
    return (
      <Routes>
        <Route path="/estimate/:id/approve" element={<ApproveEstimate />} />
      </Routes>
    );
  }

  if (isStaffRoute) {
    return (
      <Routes>
        <Route element={<ProtectedRoute><StaffPortal /></ProtectedRoute>}>
          <Route path="/staff" element={<StaffPortal />} />
        </Route>
      </Routes>
    );
  }

  if (isAdminRoute) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/admin" element={<AdminLanding />} />
          <Route path="/admin/inventory" element={<InventoryDashboard />} />
          <Route path="/admin/reports" element={<ReportsHub />} />
          <Route path="/admin/reports/finance" element={<FinanceReportsPage />} />
          <Route path="/admin/reports/invoices" element={<InvoicesReport />} />
          <Route path="/admin/reports/revenue-heads" element={<RevenueHeadsReport />} />
          <Route path="/admin/reports/gstr2" element={<Gstr2Report />} />
          <Route path="/admin/reports/cost-centre-pnl" element={<CostCentrePnl />} />
          <Route path="/admin/reports/expenses" element={<ExpensesReport />} />
          <Route path="/admin/reports/inspections-pending" element={<InspectionsPendingReport />} />
          <Route path="/admin/reports/inventory" element={<InventoryReport />} />
          <Route path="/admin/reports/parts-sales" element={<PartsSalesReport />} />
          <Route path="/admin/reports/purchasing" element={<PurchasingReports />} />
          <Route path="/admin/vendors" element={<PurchasingPage />} />
          <Route path="/admin/labour-chart" element={<LabourChartPage />} />
          <Route path="/admin/import" element={<DataImportPage />} />
          <Route path="/admin/job-cards" element={<JobCardsList />} />
          <Route path="/admin/job-cards/new" element={<JobCardForm />} />
          <Route path="/admin/job-cards/:id" element={<JobCardForm />} />
          <Route path="/admin/reports/ot-reasons" element={<OtReasonsReport />} />
          <Route path="/admin/expenses" element={<ExpensesPage />} />
          <Route path="/admin/expenses/team" element={<TeamExpensesPage />} />
          <Route path="/admin/expenses/recurring" element={<RecurringPage />} />
          <Route path="/admin/staff" element={<StaffPage />} />
          <Route path="/admin/my-attendance" element={<MyAttendancePage />} />
          <Route path="/admin/payroll" element={<PayrollPage />} />
          <Route path="/admin/performance" element={<PerformancePage />} />
          <Route path="/admin/performance/calibration" element={<CalibrationPage />} />
          <Route path="/admin/performance/plans" element={<PipsPage />} />
          <Route path="/admin/performance/team-analysis" element={<TeamAnalysisPage />} />
          <Route path="/admin/performance/reviews/:rid" element={<ReviewDetailPage />} />
          <Route path="/admin/my-performance" element={<MyPerformancePage />} />
          <Route path="/admin/skills" element={<SkillMatrixPage />} />
          <Route path="/admin/skills/training" element={<TrainingPlanPage />} />
          <Route path="/admin/skills/duty-templates" element={<DutyTemplatesPage />} />
          <Route path="/admin/skills/catalogue" element={<SkillCataloguePage />} />
          <Route path="/admin/sop" element={<SopLibraryPage />} />
          <Route path="/admin/sop/:fid" element={<SopFlowPage />} />
          <Route path="/admin/skills/staff/:sid" element={<SkillSheetPage />} />
          <Route path="/admin/settings/password" element={<ChangePassword />} />
          <Route path="/admin/inspections" element={<Inspections />} />
          <Route path="/admin/inspections/new" element={<InspectionForm />} />
          <Route path="/admin/inspections/:id" element={<InspectionForm />} />
          <Route path="/admin/used-car-inspections" element={<UsedCarInspections />} />
          <Route path="/admin/used-car-inspections/new" element={<UsedCarInspectionForm />} />
          <Route path="/admin/used-car-inspections/:id" element={<UsedCarInspectionForm />} />
          <Route path="/admin/billing/customers" element={<Customers />} />
          <Route path="/admin/billing/warranties" element={<WarrantiesList />} />
          <Route path="/admin/billing/estimates" element={<BillingList type="estimate" />} />
          <Route path="/admin/billing/estimates/new" element={<BillingForm type="estimate" />} />
          <Route path="/admin/billing/estimates/:id" element={<BillingForm type="estimate" />} />
          <Route path="/admin/billing/collections" element={<CollectionsPage />} />
          <Route path="/admin/feedback" element={<FeedbackPage />} />
          <Route path="/admin/billing/invoices" element={<BillingList type="invoice" />} />
          <Route path="/admin/billing/invoices/new" element={<BillingForm type="invoice" />} />
          <Route path="/admin/billing/invoices/:id" element={<BillingForm type="invoice" />} />
          <Route path="/admin/settings" element={<BillingSettings />} />
          {/* Settings used to live here; old links and bookmarks still work. */}
          <Route path="/admin/billing/settings" element={<Navigate to="/admin/settings" replace />} />
          <Route path="/admin/billing/vehicle-catalog" element={<VehicleCatalog />} />
          <Route path="/admin/gst/invoices" element={<GstInvoicesList />} />
          <Route path="/admin/gst/invoices/new" element={<GstInvoiceRoute />} />
          <Route path="/admin/gst/invoices/:id" element={<GstInvoiceRoute />} />
          <Route path="/admin/gst/hsn" element={<HsnMasterPage />} />
          <Route path="/admin/gst/returns" element={<GstReturnsPage />} />
          <Route path="/admin/gst/settings" element={<GstSettingsPage />} />
          <Route path="/admin/users" element={<AdminUsersPage />} />
          <Route path="/admin/subscription" element={<SubscriptionPage />} />
          <Route path="/admin/platform" element={<PlatformConsole />} />
          <Route path="/admin/platform/leads" element={<LeadsInbox />} />
          <Route path="/admin/platform/migrations" element={<MigrationsDesk />} />
          <Route path="/admin/platform/migrations/:id" element={<MigrationDetail />} />
          <Route path="/admin/platform/support" element={<SupportTickets />} />
          <Route path="/admin/platform/health" element={<PlatformHealth />} />
          <Route path="/admin/platform/packages" element={<PackagesPage />} />
          <Route path="/admin/activity-log" element={<ActivityLogPage />} />
          <Route path="/admin/marketplace" element={<AdminMarketplace />} />
          <Route path="/admin/marketplace/new" element={<AdminMarketplaceForm />} />
          <Route path="/admin/marketplace/:id/edit" element={<AdminMarketplaceForm />} />
          <Route path="/admin/appointments" element={<AppointmentsPage />} />
          <Route path="/admin/pickups" element={<PickupsPage />} />
          <Route path="/admin/appointments/new" element={<AppointmentForm />} />
          <Route path="/admin/appointments/today-cards" element={<TodayCards />} />
          <Route path="/admin/appointments/:id" element={<AppointmentForm />} />
        </Route>
      </Routes>
    );
  }

  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/training" element={<Training />} />
        <Route path="/ppf" element={<PPF />} />
        <Route path="/e-warranty" element={<EWarranty />} />
        <Route path="/ewarranty" element={<EWarranty />} />
        <Route path="/verify/:tenantId" element={<WarrantyVerify />} />
        <Route path="/gallery" element={<Gallery />} />
        {/* Public marketplace surfaces — gated by REACT_APP_MARKETPLACE_ENABLED. */}
        {String(process.env.REACT_APP_MARKETPLACE_ENABLED ?? 'true').toLowerCase() !== 'false' ? (
          <>
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/marketplace/:id" element={<MarketplaceCar />} />
            <Route path="/my-listings" element={<MyListings />} />
            <Route path="/sell-your-car" element={<SellYourCar />} />
            <Route path="/sell-your-car/:id" element={<SellYourCar />} />
          </>
        ) : (
          <>
            <Route path="/marketplace" element={<Navigate to="/" replace />} />
            <Route path="/marketplace/:id" element={<Navigate to="/" replace />} />
            <Route path="/my-listings" element={<Navigate to="/" replace />} />
            <Route path="/sell-your-car" element={<Navigate to="/contact" replace />} />
            <Route path="/sell-your-car/:id" element={<Navigate to="/contact" replace />} />
          </>
        )}
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
        {/* Driveline — the SaaS product sold to other workshops. */}
        <Route path="/driveline" element={<SiteShell><DrivelineHome /></SiteShell>} />
        <Route path="/driveline/pricing" element={<SiteShell><DrivelinePricing /></SiteShell>} />
        <Route path="/driveline/compare" element={<SiteShell><DrivelineCompare /></SiteShell>} />
        <Route path="/driveline/stories" element={<SiteShell><DrivelineStories /></SiteShell>} />
        <Route path="/driveline/switch" element={<SiteShell><DrivelineSwitch /></SiteShell>} />
        <Route path="/driveline/switch/hi" element={<SiteShell><DrivelineSwitch lang="hi" /></SiteShell>} />
        <Route path="/driveline/switch/kn" element={<SiteShell><DrivelineSwitch lang="kn" /></SiteShell>} />
        <Route path="/driveline/switch/track/:code" element={<SiteShell><DrivelineSwitchTrack /></SiteShell>} />
        <Route path="/driveline/refund-policy" element={<SiteShell><DrivelineRefund /></SiteShell>} />
        <Route path="/driveline/terms" element={<SiteShell><DrivelineTerms /></SiteShell>} />
        <Route path="/driveline/privacy" element={<SiteShell><DrivelinePrivacy /></SiteShell>} />
        <Route path="/driveline/guides" element={<SiteShell><DrivelineGuides /></SiteShell>} />
        <Route path="/driveline/solutions/:slug" element={<SiteShell><SolutionPage /></SiteShell>} />
        <Route path="/driveline/features/:slug" element={<SiteShell><FeaturePage /></SiteShell>} />
        <Route path="/driveline/demo/:token" element={<SiteShell><DemoManage /></SiteShell>} />
        <Route path="/book" element={<BookAppointment />} />
        <Route path="/book-appointment" element={<BookAppointment />} />
      </Routes>
    </PublicLayout>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider>
          <TenantProvider>
          <LangProvider>
            <div className="min-h-screen bg-white">
              <AppRoutes />
            </div>
            <ThemedToaster />
            <WhatsAppShareHost />
            <NetBanner />
          </LangProvider>
          </TenantProvider>
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
